import React from "react";
import axios from "axios";
import { baseurl } from "../../constant";

const VirtualAccount = (props) => {
  const token = localStorage.getItem("authToken");
  const getdata = async () => {
    const result = await axios.post(baseurl + "oldWalletAuth", {
      token: token,
    });
  };

  const handelclick = async () => {
    getdata();
    alert("activated");
  };

  return (
    <>
      <div className="card shadow ">
        <div className="card-header py-3">
          <div className="row">
            <div className="col-sm-6">
              <h4>
                <b>Virtual Account Detail</b>
              </h4>
            </div>

            <div className="col-sm-6  text-right">
              {/* <button
                onclick="window.history.back()"
                className="btn btn-primary"
              >
                <i className="fa fa-arrow-left"> Back</i>
              </button> */}
            </div>
          </div>
        </div>
        <div className="card-body">
          <input type="hidden" value="https://www.payol.in/" id="siteUrl" />
          <div className="row">
            <table className="table">
              {props.VirtualAccountActive == 1 && (
                <thead>
                  <tr>
                    <th scope="col">Virtual Account Numbe</th>
                    <th scope="col">IFSC Code</th>
                    <th scope="col">Bank Name</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
              )}
              {props.VirtualAccountActive == 1 && (
                <tbody>
                  <tr>
                    <td>{props.virtualAccountNo}</td>
                    <td>{props.ifsc}</td>
                    <td>{props.bankname}</td>
                    <td>
                      <button className="btn btn-primary"> Active</button>
                    </td>
                  </tr>
                </tbody>
              )}

              <thead>
                {props.VirtualAccountActive == 0 && (
                  <tr>
                    <td scope="col">Service</td>
                    <td scope="col">Status</td>
                  </tr>
                )}
              </thead>
              <tbody>
                {props.VirtualAccountActive == 0 && (
                  <tr>
                    <td>Virtual Accpunt</td>
                    <td>
                      <button className="btn btn-primary" onClick={handelclick}>
                        {" "}
                        Active
                      </button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default VirtualAccount;
